import { hFetch } from './hFetch';

export const listTeamUsers = async () => {
  return await hFetch({ url: '/api/teams/1' });
};

export const getTeam = async () => {
  return await hFetch({ url: '/api/teams/1' });
};
